import { useEffect } from 'react';
import { useAuth } from '../auth/authHooks';
import {
  flushProductAnalytics,
  recordVerifiedAttribution,
  startProductAnalytics,
} from '../../../analytics/productAnalyticsRuntime';

/** v2 shell owner for outbox start, reconnect flush, and verified-auth attribution. */
export function ProductAnalyticsOwner() {
  const { user } = useAuth();

  useEffect(() => {
    void startProductAnalytics().catch(() => undefined);
    const flush = () => { void flushProductAnalytics().catch(() => undefined); };
    window.addEventListener('online', flush);
    return () => window.removeEventListener('online', flush);
  }, []);

  useEffect(() => {
    if (user?.email) void recordVerifiedAttribution().catch(() => undefined);
  }, [user?.email]);

  return null;
}
